import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import CustomerListView from './CustomerListView';
import CustomerDetailView from './CustomerDetailView';
import RuleSetDetailView from './RuleSetDetailView';
import AugmentationRulesView from './augmentation/AugmentationRulesView';
import RuleTestingView from './augmentation/RuleTestingView';
import ReferenceDataView from './augmentation/ReferenceDataView';
import AliasManagementView from './augmentation/AliasManagementView';
import AugmentationReviewQueueView from './augmentation/AugmentationReviewQueueView';
import ProvisioningWizard from './provisioning/ProvisioningWizard';
import ErrorBoundary from '../shared/ErrorBoundary';

/**
 * CustomerManagementPage - Main orchestrator for customer management UI
 * 
 * This component manages routing for the customer management feature:
 * - /customers - Customer List View
 * - /customers/:customerId - Customer Detail View
 * - /customers/:customerId/rulesets/:rulesetId - Rule Set Detail View
 * - /customers/:customerId/augmentation/* - Augmentation feature views
 * 
 * Each view is wrapped in an ErrorBoundary to prevent component errors from crashing the entire app.
 */
const CustomerManagementPage = () => {
  return (
    <Container fluid>
      <Routes>
        <Route index element={
          <ErrorBoundary>
            <CustomerListView />
          </ErrorBoundary>
        } />
        <Route path="provision" element={
          <ErrorBoundary>
            <ProvisioningWizard />
          </ErrorBoundary>
        } />
        <Route path=":customerId" element={
          <ErrorBoundary>
            <CustomerDetailView />
          </ErrorBoundary>
        } />
        <Route path=":customerId/rulesets/:rulesetId" element={
          <ErrorBoundary>
            <RuleSetDetailView />
          </ErrorBoundary>
        } />
        <Route path=":customerId/augmentation/rules" element={
          <ErrorBoundary>
            <AugmentationRulesView />
          </ErrorBoundary>
        } />
        <Route path=":customerId/augmentation/rule-testing" element={
          <ErrorBoundary>
            <RuleTestingView />
          </ErrorBoundary>
        } />
        <Route path=":customerId/augmentation/reference-data" element={
          <ErrorBoundary>
            <ReferenceDataView />
          </ErrorBoundary>
        } />
        <Route path=":customerId/augmentation/aliases" element={
          <ErrorBoundary>
            <AliasManagementView />
          </ErrorBoundary>
        } />
        <Route path=":customerId/augmentation/review-queue" element={
          <ErrorBoundary>
            <AugmentationReviewQueueView />
          </ErrorBoundary>
        } />
      </Routes>
    </Container>
  );
};

export default CustomerManagementPage;
